import { AuthState, initialAuthState } from "../state/auth";
import { Action, createReducer, on } from "@ngrx/store";
import * as AuthActions from "../actions/auth.actions";


const reducer = createReducer(
  initialAuthState,
  on(AuthActions.loginWithToken, (state: AuthState, {token}) => ({...state, token: token})),
  on(AuthActions.loginSuccess, (state: AuthState, {token, user}) => ({...state, token: token, user: {...user, id: Number(user.id)}})),
  on(AuthActions.loginWithTokenSuccess, (state: AuthState, {token, user}) => ({...state, token: token, user: {...user, id: Number(user.id)}})),
  on(AuthActions.refreshTokenSuccess, (state: AuthState, {token}) => ({...state, token})),
  // // clear the state completely
  on(AuthActions.clearUser, state => ({...state, user: null})),
  on(AuthActions.logoutSuccess, () => initialAuthState),
  on(AuthActions.logoutFailure, () => initialAuthState)
);

export function authStateReducer(state: AuthState | undefined, action: Action) {
  return reducer(state, action);
}

export const rootReducer = authStateReducer;
